const agentStyles = {
  agentHeading: {
    fontFamily: "Playfair Display",
    fontSize: "20px",
    fontWeight: "500",
    paddingX: "2rem",
    paddingBottom: "1rem",
  },
  agentContent: {
    fontFamily: "Noto Sans",
    fontSize: " 18px",
    fontColor: "rgba(29, 37, 43, 1)",
    fontWeight: "400",
    "@media (max-width: 699px)": {
      fontSize: "14px",
    },
  },
  agentInnerContent: {
    fontFamily: "Noto Sans",
    fontSize: { xs: "14px", sm: "18px" },
    fontColor: "rgba(29, 37, 43, 1)",
    fontWeight: "250",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer",
    width: "100%",
    "@media (max-width: 699px)": {
      minWidth: "100px",
      fontSize: "14px",
    },
  },
  agentsCard: {
    display: "flex",
    gap: "10px",
    padding: "20px",
    borderRadius: "6px",
    width: "400px",
    flexDirection: "column",
    alignSelf: "flex-start",
    "@media (max-width: 699px)": {
      width: "100%",
    },
  },

  agentBoxStyles: {
    width: "100%",
    display: "flex",
    gap: 2,
    paddingX: "2rem",
    height: "100%",
    marginBottom: "20px",
  },
};

export default agentStyles;
